import React from 'react';

import {
  FormControl,
  FormLabel,
  Text,
  FormHelperText,
  Textarea,
  Flex,
  Tooltip,
  Box,
} from '@chakra-ui/react';
import { useField } from 'formik';

import { FormikTextAreaProps } from './FormikTextArea.props';
import { MdInfo } from 'react-icons/md';

const FormikTextAreaView = ({
  name,
  label,
  helperText,
  error,
  infoText,
  description,
  labelProps = {},
  ...props
}: FormikTextAreaProps): JSX.Element => {
  const [{ value }, meta, field] = useField(name);
  return (
    <FormControl mt={2}>
      {label && (
        <Flex position="relative" flexDir={description ? 'column' : 'row'}>
          <FormLabel
            fontSize="12px"
            fontWeight="600"
            htmlFor={name}
            color="#afafaf"
            textTransform="capitalize"
            {...labelProps}>
            {label}
          </FormLabel>
          {description && (
            <Box fontSize="12px" color="#afafaf" mb={2} h={8}>
              {description}
            </Box>
          )}
          {infoText && (
            <Tooltip label={infoText} hasArrow borderRadius="10px" p="15px">
              <Box>
                <MdInfo size="20px" color="primary.500" />
              </Box>
            </Tooltip>
          )}
        </Flex>
      )}
      <Textarea
        {...props}
        type={name}
        id={name}
        defaultValue={value}
        isInvalid={Boolean(error || meta.error)}
        aria-describedby={`${name}-helper-text`}
        onChange={(e) => field.setValue(e.target.value)}
        bg={props.isReadOnly ? '#F3F3F3' : 'inputColor'}
        isReadOnly={props.isReadOnly}
      />

      {helperText && <FormHelperText>{helperText}</FormHelperText>}
      {(error || meta.error) && (
        <Text color="red.500" fontSize="sm">
          {error || meta.error}
        </Text>
      )}
    </FormControl>
  );
};

export default FormikTextAreaView;
